<template>
  <div
    :class="['tq-search-input',isBorder && 'border']"
    :style="{
      width: inputWidth,
      '--bgColor': backgroundColor,
      '--bdRadius': borderRadius,
    }"
  >
    <div class="tq-input-prefix"></div>
    <tq-input v-bind="attrs">
      <template v-for="(_, name) in slots">
        <slot :name="name"></slot>
      </template>
    </tq-input>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: "TqSearchInput",
});
import { getCurrentInstance, computed } from "vue";
import tqInput from './TqInput/index.vue'
interface Props {
  width?: string | number;
  backgroundColor?: string;
  borderRadius?: string;
}

const props = withDefaults(defineProps<Props>(), {
  backgroundColor: "#f0f0f0",
  borderRadius: "15px",
});

const instance = getCurrentInstance()?.proxy;

const slots = instance?.$slots;

const attrs = instance?.$attrs;

const inputWidth = computed(() => {
  return props.width
    ? typeof props.width === "number"
      ? props.width + "px"
      : props.width
    : "500px";
});

const isBorder = computed(() => 'border' in attrs!)

</script>

<style>
.tq-search-input {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 30px;
  width: 100%;
  padding: 0 14px;
  background: var(--bgColor);
  border-radius: var(--bdRadius);
  overflow: hidden;
}
</style>
